__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@cubeassist-ui/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3318))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(61)]).then(() => (() => (__webpack_require__(4679))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(146), __webpack_require__.e(61), __webpack_require__.e(640)]).then(() => (() => (__webpack_require__(3986))))));
			register("oidc-client-ts", "3.5.0", () => (() => (__webpack_require__(2074))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(316))), 1);
			register("react-oidc-context", "3.3.1", () => (() => (__webpack_require__(8187))), 1);
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(146)]).then(() => (() => (__webpack_require__(5772))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(2155))), 1);
			initExternal(8040);
			initExternal(5478);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};